import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter);





function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    next();
  } else {
    next('/login');
  }
}










  const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/auth/login.vue'),
    beforeEnter: loggedInRedirectDashboard,
  },



  {
    path: '/',
    name: 'Home',
    component: () => import('../views/program_kegiatan/program.vue'),
    beforeEnter: isLoggedIn,
  },


 
  {
    path: '/menuList',
    name: 'menuList',
    component: () => import('../views/dataMaster/menuList.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/klpUsers',
    name: 'klpUsers',
    component: () => import('../views/dataMaster/klpUsers.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/registrasi',
    name: 'registrasi',
    component: () => import('../views/dataMaster/registrasi.vue'),
    beforeEnter: isLoggedIn,
  },
  
  {
    path: '/program',
    name: 'program',
    component: () => import('../views/program_kegiatan/program.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/kegiatan',
    name: 'kegiatan',
    component: () => import('../views/program_kegiatan/kegiatan.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/sosialisasi',
    name: 'sosialisasi',
    component: () => import('../views/sosialisasi_konsultasi/sosialisasi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/konsultasi',
    name: 'konsultasi',
    component: () => import('../views/sosialisasi_konsultasi/konsultasi.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/laporan_pajak',
    name: 'laporan_pajak',
    component: () => import('../views/pajak/laporan_pajak.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/buku_pajak',
    name: 'buku_pajak',
    component: () => import('../views/pajak/buku_pajak.vue'),
    beforeEnter: isLoggedIn,
  },
  

  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    beforeEnter: isLoggedIn,
  },


]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router
